module.exports = __webpack_public_path__ + "img/top-logo.275165c8.png";